import { useEffect, useRef } from "react";

// Animated bar waveform. When `analyser` is present it reflects live mic input;
// otherwise it renders a gentle idle pulse.
export default function Waveform({ analyser, active = false, color = "#0A0A0A", bars = 32, height = 90 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    const cssW = canvas.clientWidth, cssH = height;
    canvas.width = cssW * dpr; canvas.height = cssH * dpr;
    ctx.scale(dpr, dpr);

    const data = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;
    let raf, t = 0;

    const draw = () => {
      raf = requestAnimationFrame(draw);
      ctx.clearRect(0, 0, cssW, cssH);
      const gap = 4;
      const bw = (cssW - gap * (bars - 1)) / bars;
      if (analyser) analyser.getByteFrequencyData(data);
      for (let i = 0; i < bars; i++) {
        let v;
        if (analyser) {
          const idx = Math.floor((i / bars) * data.length);
          v = data[idx] / 255;
        } else {
          v = active ? 0.15 + 0.12 * Math.abs(Math.sin(t / 12 + i / 3)) : 0.08;
        }
        const bh = Math.max(4, v * cssH);
        const x = i * (bw + gap);
        const y = (cssH - bh) / 2;
        ctx.fillStyle = color;
        const r = Math.min(bw / 2, 3);
        ctx.beginPath();
        ctx.roundRect(x, y, bw, bh, r);
        ctx.fill();
      }
      t++;
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [analyser, active, color, bars, height]);

  return <canvas ref={canvasRef} style={{ width: "100%", height }} className="block" />;
}
